import { createSelector } from 'reselect'
import { createSelector as ormCreateSelector } from 'redux-orm'
import orm from '../../models/models'

export const currentUser = createSelector(
  state => state.orm,
  state => state.users.currentUserUsername,
  ormCreateSelector(orm, (session, username) => {
    return session.User.withId(username)
  })
)
